const set =
{
    helmet :
    {
        title : 'Configurations' ,
        metas : []
    }
};

export default set ;